module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// ./node_modules/browserify-sign/algos.js
// module id = 93
// module chunks = 0